<template>
    <modal
        name="productos-qr"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="productos-qr"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Listado de productos a {{ accion_qr.includes('reactivar') ? 'reactivar' : 'activar' }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <ContentOrLoading>
                <template v-if="!loading">
                    <ProductosComponent
                        v-if="productos.length"
                        :productos="productos"
                        :qr_code="qr_code"
                        @confirm="terminar"
                        @close="close"
                    />
                    <div class="alert alert-info m-4" v-else>
                        <b>No hay productos a validar</b>
                    </div>
                </template>
            </ContentOrLoading>
        </div>
    </modal>
</template>

<script>
import axios from "axios";
import ProductosComponent from "../ProductosComponent.vue";
import { computed } from "vue";

export default {
    props: ["accion_qr", "codigo_evento", "sesion_id", "qr_code", "titleText"],
    data() {
        return {
            loading: false,
            productos: []
        };
    },
    methods: {
        async getProductos() {
            this.loading = true;

            try {
                const response = await axios.get(
                    `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/productos/${this.qr_code}`
                );

                console.log(this.accion_qr);

                if (this.accion_qr === 'validar-productos') {
                    this.productos = response.data.data.filter(producto => producto.hora_recogida == null);
                } else if (this.accion_qr === 'reactivar-productos') {
                    this.productos = response.data.data.filter(producto => producto.hora_recogida != null);
                }

                this.loading = false;
            } catch (error) {
                console.error("Error:", error);
                this.loading = false;
            }
        },
        terminar(productosSeleccionados) {
            this.$emit("confirm", productosSeleccionados, "productos-qr");
        },
        close() {
            this.$emit("close", "productos-qr");
        }
    },
    computed: {
        accionQrYcodigo() {
            return `${this.qr_code}-${this.accion_qr}`;
        }
    },
    watch: {
        accionQrYcodigo: {
            handler: _.debounce(function() {
                if (this.qr_code) {
                    this.getProductos();
                }
            }, 500),
            immediate: false
        }
    },
    components: {
        ProductosComponent
    }
};
</script>